export default __webpack_public_path__ + "static/media/img1.6773b518.png";